import type {
  Control,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";

import {
  TIME_END_DAY_HHmm,
  ZERO_TIME_HHmm,
  type TTimeHHmm,
} from "@ryde/shared";

export interface IRatioItem {
  areaId?: number;
  ratio: number | "";
  from: TTimeHHmm | "";
  to: TTimeHHmm | "";
}

/** A row as displayed, paired with the index it holds in the stored (unsorted) form array. */
export interface IRatioSortedEntry {
  item: IRatioItem;
  formIndex: number;
}

export interface IRatioFormItem {
  areaId?: number;
  ratio: number | "";
  from: TTimeHHmm | null;
  to: TTimeHHmm | null;
}

export interface IRatioItemFormProps {
  fieldName: string;
  control?: Control;
  /** Index in the stored form array, not in the sorted display order. */
  index?: number;
  onEdit?: () => void;
  onCancel?: () => void;
  value?: Partial<IRatioItem>;
  setValue: UseFormSetValue<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  removeHandler?: (index: number) => void;
  onEditStart?: () => void;
  onEditEnd?: () => void;
}

/**
 * A new row opens on a whole-day window. The time pickers render a placeholder time for an empty
 * value while the form value stays unset, so an empty `from`/`to` looks filled but fails their
 * required rule and leaves the save button disabled with nothing on screen explaining why.
 */
export const emptyRatio: IRatioItem = {
  areaId: undefined,
  ratio: "",
  from: ZERO_TIME_HHmm,
  to: TIME_END_DAY_HHmm,
};
